import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_female",
  "use": "icon-icon_female-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_female\"><defs><style></style></defs><path d=\"M874.906 150.938a348.16 348.16 0 0 0-512 471.04l-85.607 85.606-125.133-125.542a25.6 25.6 0 1 0-36.25 36.25L241.87 744.242 54.682 931.43a25.6 25.6 0 1 0 36.25 36.25l187.186-187.187L404.07 906.445a25.6 25.6 0 1 0 36.25-36.25L314.368 744.243l85.402-85.401a348.16 348.16 0 0 0 475.136-507.904zm-35.226 456.09a296.96 296.96 0 1 1 0-419.84 295.117 295.117 0 0 1 0 419.84z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol